import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Globe } from 'lucide-react';
import { alternatePath, langFromPath } from '../i18n/paths';

const LanguageSwitcher = ({ className = '' }) => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const current = langFromPath(location.pathname);

  const toggle = () => {
    const next = current === 'it' ? 'en' : 'it';
    const targetPath = alternatePath(location.pathname);
    i18n.changeLanguage(next);
    try { document.documentElement.lang = next; } catch (e) { /* no-op */ }
    navigate(targetPath);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="language-switcher"
      aria-label={current === 'it' ? 'Switch to English' : 'Passa all\'italiano'}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs font-semibold text-[var(--color-text)] hover:bg-[var(--color-border)]/40 transition-colors ${className}`}
    >
      <Globe className="w-4 h-4" />
      <span className={current === 'it' ? 'text-[var(--color-primary)]' : 'text-[var(--color-text-muted)]'}>IT</span>
      <span className="text-[var(--color-text-muted)]">/</span>
      <span className={current === 'en' ? 'text-[var(--color-primary)]' : 'text-[var(--color-text-muted)]'}>EN</span>
    </button>
  );
};

export default LanguageSwitcher;
